import { Filmstrip } from '../../abstract/filmstrip.class';
import { FilmstripType } from '../../abstract/filmstrip.type';
import { Background } from '../../object';
import { Font } from '../../object/font/font.class';
import { Text } from '../../object/text/text.class';
import { $ } from '../../signal';
import { ScoreModule } from '../score.class';

export class ScoreSection2Answer extends Filmstrip<ScoreModule> {
  public name = '公佈答案';

  public override readonly type = FilmstripType.SCORE_SECTION_2_RANK;

  public override readonly withMobileInteractive = true;

  public projection = {
    background: new Background({
      type: 'IMAGE',
      src: 'assets/score/answer.jpg',
    }),
    publishTheAnswer: new Font({ align: 'center' }),
    answer: new Font({ align: 'center' }),
    currentRank: new Text({ content: '目前戰況', align: 'center' }),
    numberOfWinner: new Font(),
    wrongFont: new Font({ align: 'center' }),
  };

  public mobile = {
    background: new Background({ hex: '#D0D9E4' }),
    correctText: new Text({ content: '答對了', align: 'center' }),
  };

  public data = {};

  public override nextButtonName = '下一題';

  public mobileToolbar = {
    options: ['答對', '答錯'],
    selectedOptionIndex: 0,
  };

  public override _processError = $.computed(() => ({
    'projection.background': this.projection.background.error(),
    'projection.publishTheAnswer': this.projection.publishTheAnswer.error(),
    'projection.answer': this.projection.answer.error(),
    'projection.numberOfWinner': this.projection.numberOfWinner.error(),
    'mobile.background': this.mobile.background.error(),
    'mobile.correctText': this.mobile.correctText.error(),
  }));
}
